import { FC, useCallback } from "react";
import { MotivationGroupEvaluated } from "tm-shared/types";

import { DashboardCollapse } from "@/features/Dashboard/components/DashboardCollapse";

import type { SelfPlanModalState } from "../../types";
import { useKPICollapseItems } from "./hooks/useKPICollapseItems";
import { KPICollapseHeader } from "./KPICollapseHeader";
import { deriveKPIMetadata } from "./utils";

interface KPICollapseProps {
    evaluatedMotivationGroup: MotivationGroupEvaluated;
    setModalData: (data: SelfPlanModalState) => void;
}

export const KPICollapse: FC<KPICollapseProps> = ({
    evaluatedMotivationGroup,
    setModalData,
}) => {
    const metadata = deriveKPIMetadata(evaluatedMotivationGroup);
    const collapseItems = useKPICollapseItems(metadata);

    const handleInfoClick = useCallback(
        (modalState: SelfPlanModalState) => {
            setModalData(modalState);
        },
        [setModalData],
    );

    return (
        <DashboardCollapse
            header={<KPICollapseHeader metadata={metadata} />}
            items={collapseItems}
            onInfoClick={handleInfoClick}
        />
    );
};
